import React from 'react';
import { Button, Col, Input, Radio, Row, Select } from 'antd';
import * as FaIcons from 'react-icons/fa';
import './styles.css';
import { urlIconeModuloImagem } from '../../services/request/urls';
import IconPickerFontAwesome from '../IconPickerFontAwesome';
import { ReactSortable } from 'react-sortablejs';
import { IAlteracoes } from '../../pages/ConfiguracoesDoSistema/components/Aplicativo/ListVersaoApp/useListVersaoApp';
import useInputAppChanges from './useInputAppChanges';


interface IconPickerProps {
    value?: IAlteracoes[];
    onChange?: (alteracoes: IAlteracoes[]) => void;
    name?: string;
}


const InputAppChanges: React.FC<IconPickerProps> = ({ value, onChange, name }) => {

    const {
        modulos,
        loadingData,
        selectedModule,
        propsState,
        handleChangeModuleVisible,
        moduleVisible,
        handleSelectModule,
        selectedIcon,
        handleSelectIcon,
        titulo,
        setTitulo,
        descricao,
        setDescricao,
        isEditing,
        handleInsertAlteracoes,
        handleUpdateAlteracoes,
        handleEditAlteracoes,
        handleRemoveAlteracoes,
        handleCancelEdit,
        alteracoes,
        setAlteracoes
    } = useInputAppChanges({value, onChange});




    return (
        <div>
            <input type="hidden" name={name} value={selectedModule} />

            <Row gutter={[16, 8]} style={{
                backgroundColor: propsState.theme === 'light' ? '#f1f1f1' : '#242424',
                padding: '16px',
                borderRadius: '8px'
            }}>
                <Col span={5} style={{ display: 'flex', flexDirection: 'column' }}>
                    <label>Tipo:</label>
                    <Radio.Group onChange={(e) => handleChangeModuleVisible(e.target.value)} value={moduleVisible}>
                        <Radio.Button value={true}>Módulo</Radio.Button>
                        <Radio.Button value={false}>Ícone</Radio.Button>
                    </Radio.Group>
                </Col>
                {moduleVisible ? <Col span={8}>
                    <label>* Módulo:</label>
                    <Select
                        showSearch
                        optionFilterProp="children"
                        onChange={handleSelectModule}
                        value={selectedModule}
                        filterOption={(input: any, option: any) =>
                            (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                        }>
                        <Select.Option value="">Selecione</Select.Option>
                        {modulos.map((modulo, index) => {
                            return (
                                <Select.Option key={index} value={modulo.nome}>
                                    <img width={20} style={{ marginRight: '8px' }} src={urlIconeModuloImagem + modulo.icone?.file} /> {modulo.nome}
                                </Select.Option>
                            );
                        })}
                    </Select>
                </Col> :
                    <Col span={8}>
                        <label>* Ícone:</label>
                        <IconPickerFontAwesome
                            name="iconeId"
                            value={selectedIcon}
                            onChange={handleSelectIcon}
                        />
                    </Col>}
                <Col span={11}>
                    <label>* Título:</label>
                    <Input value={titulo} onChange={(e) => setTitulo(e.target.value)} />
                </Col>
                <Col span={24}>
                    <label>Descrição:</label>
                    <Input.TextArea value={descricao} onChange={(e) => setDescricao(e.target.value)} placeholder={selectedModule ? `Descrição do que foi alterado no módulo de ${selectedModule}` : 'Descrição da alteração'} />
                </Col>
                <Col span={24} style={{ textAlign: 'right', marginTop: '16px' }}>
                    <Button type="primary" style={{ marginRight: '8px', backgroundColor: '#f5222d', borderColor: '#f5222d' }} onClick={handleCancelEdit}> Cancelar</Button>
                    {!isEditing ? <Button type="primary" onClick={handleInsertAlteracoes}> Adicionar</Button>
                        : <Button type="primary" onClick={handleUpdateAlteracoes}> Editar</Button>}
                </Col>
            </Row>
            <Row style={{ maxHeight: '350px', overflowY: 'auto' }}>
                <ReactSortable
                    list={alteracoes as any}
                    setList={(alteracoes) => setAlteracoes(alteracoes as any)}
                    animation={150}
                    style={{ width: '100%' }}
                    className='ant-row'
                >
                    {alteracoes.map((alteracao, index) => {
                        const IconComponent = alteracao.icone && FaIcons[alteracao.icone.originalName as keyof typeof FaIcons];
                        return (
                            <Col key={index} span={24} style={{ marginTop: '10px', cursor: 'pointer', }}>
                                <div style={{ backgroundColor: propsState.theme === 'light' ? '#f1f1f1' : '#242424', padding: '5px', borderRadius: '4px' }}>
                                    <Row style={{ alignItems: 'center' }}>
                                        <Col span={2} style={{ paddingLeft: '8px' }}>
                                            {alteracao.imagem && <img width={40} src={urlIconeModuloImagem + alteracao.imagem.file} />}
                                            {IconComponent && <IconComponent size={40} color="#2d9cdb" />}
                                        </Col>
                                        <Col span={18}>
                                            <Row>
                                                <Col span={24}>
                                                    <h4>{alteracao.titulo}</h4>
                                                </Col>
                                                <Col span={24}>
                                                    <p>{alteracao.descricao}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={4}>
                                            <Button type='primary' className='botaoDeleteAssociacao' onClick={() => handleEditAlteracoes(alteracao)}><FaIcons.FaEdit /></Button>
                                            <Button className='botaoDeleteAssociacao' danger type='primary' onClick={() => handleRemoveAlteracoes(alteracao)} style={{ marginBottom: '5px' }}> <FaIcons.FaTrash /> </Button>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        );
                    })}
                </ReactSortable>
            </Row>
        </div>
    );
};

export default InputAppChanges;
